<template>
  <div class="bg-gray-200 text-gray-700">
    <div
      class="h-screen container mx-auto p-8 lg:p-0 flex items-center justify-center"
    >
      <div class="w-full max-w-md bg-white rounded-lg shadow-2xl">
        <div class="p-8">
          <div v-if="!userIsAdmin" class="mb-5">
            <label class="block mb-2 text-sm font-medium text-gray-600"
              >Usuario</label
            >
            <input
              type="text"
              class="block w-full p-3 rounded bg-gray-200 border border-transparent focus:outline-none"
              v-model="user"
            />
          </div>
          <div v-if="!userIsAdmin" class="mb-5">
            <label class="block mb-2 text-sm font-medium text-gray-600"
              >Contraseña</label
            >
            <input
              type="password"
              @keyup.enter="authenticate"
              class="block w-full p-3 rounded bg-gray-200 border border-transparent focus:outline-none"
              v-model="password"
            />
          </div>
          <div v-if="userIsAdmin" class="login-select mb-5">
            <label class="block mb-2 text-sm font-medium text-gray-600"
              >Grupo colegio</label
            >
            <VSelect
              :options="schoolGroups"
              v-model="schoolGroup"
              :clearable="false"
            />
          </div>
          <button
            class="w-full h-12 flex items-center justify-center mt-4 bg-indigo-600 hover:bg-opacity-75 text-white rounded shadow"
            :disabled="loading"
            @click="login"
          >
            <span v-if="!loading">Login</span>
            <span v-else class="spinner"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import VSelect from "vue-select";
import axios from "axios";
import { mapMutations } from "vuex";

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      user: "",
      password: "",
      loading: false,
      responseUser: null,
      userIsAdmin: false,
      schoolGroup: null,
      schoolGroups: [],
    };
  },
  methods: {
    ...mapMutations(["changeUser"]),
    authenticate() {
      this.loading = true;

      axios
        .post("server/index.php", {
          action: "login",
          user: this.user,
          password: this.password,
          timestamp: Date.now(),
        })
        .then((response) => {
          if (!response.data.login) {
            this.changeUser(null);
            localStorage.removeItem("user");
          }

          this.responseUser = response.data.user;

          if (this.responseUser.admin === "0") {
            this.changeUser(this.responseUser);
            localStorage.setItem("user", JSON.stringify(this.responseUser));

            this.$router.push("/");
          }

          this.loadOptions();
        });
    },
    loadOptions() {
      axios
        .post("server/index.php", {
          action: "getSchoolGroups",
          timestamp: Date.now(),
        })
        .then((response) => {
          this.schoolGroups = response.data.map((group) => {
            return {
              id: group.num,
              label: group.title,
            };
          });

          this.userIsAdmin = true;
          this.loading = false;
        });
    },
    login() {
      if (this.responseUser) {
        this.selectSchool();
      } else {
        this.authenticate();
      }
    },
    selectSchool() {
      if (this.schoolGroup === null) {
        return;
      }

      this.loading = true;

      axios
        .post("server/index.php", {
          action: "getSchoolsInsideGroup",
          schoolGroup: this.schoolGroup.id,
          timestamp: Date.now(),
        })
        .then((response) => {
          this.responseUser.colegio = this.schoolGroup.id;
          this.responseUser.colegio_title = this.schoolGroup.label;
          this.responseUser.grupos = response.data.grupos;

          this.changeUser(this.responseUser);
          localStorage.setItem("user", JSON.stringify(this.responseUser));

          this.$router.push("/");
        });
    },
  },
};
</script>
<style>
.login-select .vs__dropdown-toggle {
  padding: 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  background-color: #edf2f7;
}

.login-select .vs__search,
.login-select .vs__search:focus {
  line-height: inherit;
  font-size: inherit;
  border: none;
  margin: 0;
}

.login-select .vs__dropdown-menu {
  border-color: transparent;
}

.spinner {
  position: relative;
  color: transparent;
  pointer-events: none;
}

.spinner::after {
  content: "";
  position: absolute;
  top: calc(50% - (1.5rem / 2));
  left: calc(50% - (1.5rem / 2));
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid #fff;
  border-radius: 9999px;
  border-right-color: transparent;
  border-top-color: transparent;
  animation: spinAround 500ms infinite linear;
}

@keyframes spinAround {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
